import abandonedCarts from "./abandonedCarts"
export default abandonedCarts;
